import React, { useState, useMemo } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ReportedUserModal = ({ open, onClose, show, report, item, itemType, otherReports, id, updateReport }) => {
    const [actionNotes, setActionNotes] = useState('');
    const [currentReportIndex, setCurrentReportIndex] = useState(0);
    const reports = useMemo(() => {
        if (!report) return [];

        const filteredOthers = otherReports.filter(r => r.id !== report.id);

        return [report, ...filteredOthers];
    }, [report, otherReports]);
    const activeReport = reports[currentReportIndex];
    const totalReports = reports.length;
    const hasMultipleReports = totalReports > 1;
    const [showReasonError, setShowReasonError] = useState(false);
    
    if (!open || !item || !report) {
        return null;
    }


    const goPrevReport = () => {
        setCurrentReportIndex(i => 
            i === 0 ? totalReports - 1 : i - 1
        );
    };

    const goNextReport = () => {
        setCurrentReportIndex(i => 
            i === totalReports - 1 ? 0 : i + 1
        );
    };


    const updateReportsStatus = (status, moderatorNotes) => {
        if (!moderatorNotes.trim()) {
            setShowReasonError(true);
            return;
        }

        if (!reports || reports.length === 0) return;
        const reportIds = reports.map(r => r.id);

        updateReport({
            reportIds,
            status,
            itemId: item.id,
            itemType,
            reviewerId: id,
            moderatorNotes
        })

        onClose();
    }
    return (
        <Modal
            show={show}
            onHide={onClose}
            size="lg"
            aria-labelledby="custom-modal-styling"
            className="custom-modal"
            fullscreen="lg-down"
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div>Reported User - {item.username}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mt-4 d-flex flex-column  justify-content-between gap-3">
                    <div className="card mt-4" style={{ flex: 7,backgroundColor: "#2b2d31" }}>
                        <div className="card-body">
                            <div>
                                <h5 className="card-title" style={{ color: "white" }}>Reports</h5>

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <Button size="sm" variant="secondary" disabled={!hasMultipleReports} onClick={goPrevReport}>Prev</Button>
                                    <span>Report {currentReportIndex + 1} of {totalReports}</span>
                                    <Button size="sm" variant="secondary" disabled={!hasMultipleReports} onClick={goNextReport}>Next</Button>
                                </div>

                                <p><strong>Reason -</strong> {activeReport.reason}</p>
                                <p><strong>Reported At:</strong> {new Date(activeReport.createdAt).toLocaleString()}</p>
                                <p><strong>Reported By:</strong> {activeReport.reporter?.username}</p>
                                <hr />
                            </div>
                            <div>
                                <div>
                                    {showReasonError && (
                                        <Form.Text style={{ color: 'red' }}>Please enter a reason before submitting.</Form.Text>
                                    )}
                                </div>
                                
                                <Form.Group className="mb-3">
                                    <Form.Label>Moderator Notes</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={actionNotes}
                                        onChange={(e) => setActionNotes(e.target.value)}
                                        placeholder="Internal moderation notes..."
                                    />
                                </Form.Group>

                            </div>

                            <div className="d-flex justify-content-end gap-2">
                                <Button variant="outline-success" disabled={!actionNotes} onClick={() => updateReportsStatus('DISMISSED', actionNotes)}>Dismiss</Button>
                                <Button variant="outline-danger" disabled={!actionNotes} onClick={() => updateReportsStatus('RESOLVED', actionNotes)}>BAND</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ReportedUserModal;